// timer_utils.js

/**
 * Starts a countdown timer that updates the seconds via setSeconds and calls timerEnded
 * when the time reaches zero.
 *
 * @param {Function} isActiveGetter - A function that returns the current value of isActive.
 * @param {number} seconds - Current seconds value.
 * @param {Function} setSeconds - State setter to update the seconds.
 * @param {Function} timerEnded - Callback function when timer reaches zero.
 * @returns {number} The interval ID so it can be cleared.
 */
export const startTimer = (isActiveGetter, seconds, setSeconds, timerEnded) => {
  let interval;
  const updateFunction = () => {
    setSeconds((prevSeconds) => {
      if (prevSeconds > 1) {
        return prevSeconds - 1;
      } else {
        // When timer reaches zero, call timerEnded with the latest isActive value.
        timerEnded(isActiveGetter());
        clearInterval(interval);
        return 0;
      }
    });
  };

  // Only start if active and time remaining
  if (isActiveGetter() && seconds > 0) {
    interval = setInterval(updateFunction, 1000);
  }
  return interval;
};


/**
 * Stops recording and navigates to a specified route if the timer has ended.
 * Bury inside a useEffect to update once 
 * @param {boolean} isActive - Flag to check if the timer should be active.
 * @param {Function} stopRecording - Function to stop the recording process.
 * @param {Function} handleTimeoutNavigation - Function to handle navigation or deactivation based on platform.
 */
export const timerEnded = async (isActive, stopRecording, handleTimeoutNavigation) => {
  if (isActive) {
    stopRecording();
    handleTimeoutNavigation();
    };
  }

/**
 * Handles timeout behavior based on platform, either navigating or deactivating the mic button.
 * @param {Function} navigate - Function to navigate to the next page.
 * @param {Function} setRecordingButtonDisabled - Function to deactivate rendered buttons.
 * @param {string} nextPage - The route to navigate to if platform is whitelisted.
 */
export const handleTimeoutNavigation = (navigate, setRecordingButtonDisabled, nextPage) => {
  const isWhiteListPlatform = /Mac|Windows/.test(navigator.userAgent) && /Chrome/.test(navigator.userAgent);
  if (isWhiteListPlatform) {
    navigate(nextPage);
    } 
  else {
    setRecordingButtonDisabled(true);
    }
  };